import { useEffect, useRef, RefObject } from 'react'

/**
 * Hook parameters.
 */
interface Props extends IntersectionObserverInit {
  /**
   * Ref object from `useRef`.
   */
  ref?: RefObject<Element> | null

  /**
   * Callback to fire when the observed component or Element
   * comes into view.
   */
  callback?: IntersectionObserverCallback
}

export function useIntersectionObserver({ ref, callback, ...options }: Props) {
  const observer = useRef<IntersectionObserver>(null)

  useEffect(() => {
    if (observer.current) observer.current.disconnect()
    observer.current = new IntersectionObserver(callback, options)
    if (ref && ref.current) observer.current.observe(ref.current)
    return () => observer.current.disconnect()
  }, [ref, options, callback])
}
